<template>
    <v-row class="v-application">
        <v-col cols="12" class="pb-0">
            <v-card outlined elevation="0" class="rounded-lg mx-5 mt-3 v-application">
                <v-card-title class="d-inline-block">
                    <span class="h4">
                        Wunschprofil des FB
                    </span>
                </v-card-title>
                <section class="d-inline-block">
                    <div class="d-flex flex-wrap">
                        <span class="ml-5" v-if="pharmacy.desired_pharmacist_gender">
                            <span class="h5">Geschlecht: </span>{{ pharmacy.pretty_desired_pharmacist_gender }}
                        </span>

                        <span class="ml-4" v-if="pharmacy.desired_pharmacist_languages.length">
                            <span class="h5">Sprachen: </span>
                            <span v-for="lang in pharmacy.pretty_desired_pharmacist_languages">{{ lang }}, </span>
                        </span>

                        <span class="ml-4" v-if="pharmacy.desired_pharmacist_languages_ext">
                            <span class="h5">weitere Sprachen: </span>{{ pharmacy.desired_pharmacist_languages_ext }}
                        </span>

                        <span class="ml-4" v-if="pharmacy.desired_pharmacist_annotation">
                            <span class="h5">Anmerkungen: </span>
                            <span class="textarea-comment">{{ pharmacy.desired_pharmacist_annotation }}</span>
                        </span>
                    </div>
                </section>
            </v-card>
        </v-col>
        <v-col cols="12" class="v-application align-center">
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Suche"
                class="mx-4 pt-0 mt-0"
                hide-details
            ></v-text-field>
            <div class="v-application--is-ltr">
                <v-select
                    :items="filterOptions"
                    v-model="filter"
                    label="Filter"
                    outlined
                    clearable
                    dense
                    hide-details
                />
            </div>
            <v-btn
                @click="isFavoritesDialogOpen = true"
                class="open-pharmacist-favorite-list ml-3"
                color="success"
                small
                outlined
            >
                <v-icon small class="mr-2">mdi-pencil</v-icon> FB - Favoriten-Liste
            </v-btn>
            <v-btn
                @click="isBlacklistDialogOpen = true"
                class="open-pharmacist-blacklist mx-3"
                color="error"
                small
                outlined
            >
                <v-icon small class="mr-2">mdi-pencil</v-icon> FB - Negativ-Liste
            </v-btn>
            <favorite-pharmacist-dialog
                v-model="isFavoritesDialogOpen"
                :pharmacyId="pharmacy._id"
                :activePharmacists="activePharmacists"
                :favoriteIds="Object.keys(pharmacy.contractor_favorite_list)"
                @get-pharmacists="$emit('get-pharmacists')"
            />
            <blacklist-pharmacist-dialog
                v-model="isBlacklistDialogOpen"
                :pharmacyId="pharmacy._id"
                :activePharmacists="activePharmacists"
                :blacklistIds="pharmacy.contractor_black_list"
                @get-pharmacists="$emit('get-pharmacists')"
            />
        </v-col>
        <v-col cols="12">
            <v-data-table
                :headers="headers"
                :items="filter ? filteredtableRows : tableRows"
                :items-per-page="15"
                :search="search"
                item-key="_id"
                no-data-text="Keine Suchergebnisse"
                loading-text="Wird geladen..."
                class="v-application--is-ltr"
            >
                <template v-slot:item="{ item }">
                    <pharmacists-table-row :pharmacist="item" />
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import axios from "axios";
import { mapMutations } from 'vuex';

import PharmacistsTableRow from './PharmacistsTableRow.vue';
import FavoritePharmacistDialog from "./FavoritePharmacistDialog.vue"
import BlacklistPharmacistDialog from "./BlacklistPharmacistDialog.vue"

const TABLE_HEADERS = [
    { text: 'Name', value: 'name' },
    { text: 'Status', value: 'status' },
    { text: 'Services', value: 'services' },
    { text: 'Adresse', value: 'address' },
    { text: 'Erstellt', value: 'created_at' },
];
export default {
    props: {
        pharmacists: Array,
        pharmacy: Object
    },
    emits: ['get-pharmacists'],
    components: {
        PharmacistsTableRow,
        FavoritePharmacistDialog,
        BlacklistPharmacistDialog
    },
    data() {
        return {
            headers: TABLE_HEADERS,
            search: '',
            filter: 'favorite',
            isFavoritesDialogOpen: false,
            isBlacklistDialogOpen: false,
            filterOptions: [
                { text: 'Favoriten', value: 'favorite' },
                { text: 'Gesperrt', value: 'blacklisted' }
            ],
            activePharmacists: []
        }
    },
    computed: {
        tableRows() {
            return this.pharmacists.map(pharmacist => ({
                ...pharmacist,
                status: pharmacist.blacklisted ? 'blacklisted' : pharmacist.favorite ? 'favorite' : ''
            }));
        },
        filteredtableRows() {
            return this.pharmacists.filter(pharmacist => pharmacist[this.filter])
        }
    },
    methods: {
        async getActivePharmacists() {
            try {
                const response = await axios.get(`/pharmacists/api/active`);
                this.activePharmacists = response.data.map(pharmacist => (
                    {
                        ...pharmacist,
                        text: `${pharmacist.lastname}, ${pharmacist.firstname}`,
                        value: pharmacist._id
                    }
                ));
            } catch {
                this.alertError()
            }
        },
        ...mapMutations({
            alertError: 'alert/error',
            alertSuccess: 'alert/success'
        })
    },
    mounted() {
        this.getActivePharmacists()
    },
}
</script>

<style></style>